export default __webpack_public_path__ + "static/media/phone.62a80ef4.svg";